export enum MessageType {
  Error = 'error',
  Success = 'success',
}
